module.exports = __webpack_public_path__ + "slick.526d7fdf63614222d376.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/assets/css/plugins/fonts/slick.svg
// module id = ../../../../../src/assets/css/plugins/fonts/slick.svg
// module chunks = styles